import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
} from '@angular/core';
import { DynamicComponent } from '@form-generator-engine/abstractions';
import { BaseElement } from '@form-generator-engine/composite-pattern';
import { ComponentHostDirective } from '@form-generator-engine/directives/container.directive';
import { FactoryResolverService } from '@form-generator-engine/services/factory-resolver.service';

@Component({
  standalone: false,
  selector: 'gstar-template-factory',
  templateUrl: './template-factory.component.html',
  providers: [FactoryResolverService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateFactoryComponent {
  private readonly factoryResolverService = inject(FactoryResolverService);

  @ViewChild(ComponentHostDirective) container!: ComponentHostDirective;

  generateView<TComponent>(
    node: DynamicComponent<TComponent> & BaseElement,
    transform?: (element: DynamicComponent<TComponent>) => void
  ): void {
    this.factoryResolverService.container = this.container;
    this.factoryResolverService.generateView(node, transform);
  }

  generateViewByList<TComponent>(
    nodeList: (DynamicComponent<TComponent> & BaseElement)[],
    transform?: (element: DynamicComponent<TComponent>) => void
  ): void {
    nodeList.forEach((node: DynamicComponent<TComponent> & BaseElement) => {
      this.factoryResolverService.container = this.container;
      this.factoryResolverService.generateView(node, transform);
    });
  }
}
